module.exports = __webpack_public_path__ + "static/sky_joker-4befb37945aa96aa548c6fd8746cb390.jpg";